import React, { useState } from 'react';
import '../../styles/PequenosDuenosAdmin.css';
import { useAdminContext } from '../../context/AdminContext.js'; // Ruta corregida
import Pagination from '../../components/common/Pagination.js';

const SolicitudPequenoDueno = ({ solicitud, onAction, processingId }) => {
    const isProcessing = processingId === solicitud.id;
    const date = solicitud.createdAt?.toDate ? solicitud.createdAt.toDate().toLocaleString('es-ES') : 'N/A';

    return (
        <div className="solicitud-card">
            <div className="solicitud-header">
                <span className="solicitud-id">Usuario: {solicitud.userEmail}</span>
                <span>{date}</span>
            </div>
            <div className="solicitud-body">
                <p><strong>Nombre:</strong> {solicitud.fullName || '(No especificado)'}</p>
                <p><strong>Username:</strong> {solicitud.username || '(No especificado)'}</p>
                <p><strong>Motivo de la solicitud:</strong></p>
                <p className="motivo-text">{solicitud.reason}</p>
            </div>
            {solicitud.status === 'pendiente' && (
                <div className="solicitud-actions">
                    <button 
                        onClick={() => onAction(solicitud, 'aprobado')} 
                        disabled={isProcessing} 
                        className="login-button"
                    >
                        {isProcessing ? 'Aprobando...' : 'Aprobar'}
                    </button>
                    <button 
                        onClick={() => onAction(solicitud, 'rechazado')} 
                        disabled={isProcessing} 
                        className="reject-btn"
                    >
                        {isProcessing ? 'Rechazando...' : 'Rechazar'}
                    </button>
                </div>
            )}
        </div>
    );
};

const PequenosDuenosAdmin = () => {
    const { 
        smallOwnerRequests: requests, 
        handleSmallOwnerAction: onAction, 
        processingId 
    } = useAdminContext() || { smallOwnerRequests: [], loading: true };

    const [activeTab, setActiveTab] = useState('pendiente');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const filteredRequests = (requests || []).filter(req => req.status === activeTab);

    const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);
    const paginatedRequests = filteredRequests.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
        setCurrentPage(1);
    };

    return (
        <div className="main-panel">
            <h2 className="section-title">Solicitudes de Pequeños Dueños</h2>
            <p>Revisa y gestiona las solicitudes de los usuarios para unirse al programa de Pequeños Dueños.</p>
            
            <div className="admin-tabs">
                <button onClick={() => handleTabClick('pendiente')} className={activeTab === 'pendiente' ? 'active' : ''}>Pendientes</button>
                <button onClick={() => handleTabClick('aprobado')} className={activeTab === 'aprobado' ? 'active' : ''}>Aprobados</button>
                <button onClick={() => handleTabClick('rechazado')} className={activeTab === 'rechazado' ? 'active' : ''}>Rechazados</button>
            </div>

            {paginatedRequests.length > 0 ? (
                <div className="solicitudes-grid">
                    {paginatedRequests.map(request => (
                        <SolicitudPequenoDueno 
                            key={request.id} 
                            solicitud={request} 
                            onAction={onAction} 
                            processingId={processingId} 
                        />
                    ))}
                </div>
            ) : (
                <p className="empty-state-text" style={{ marginTop: '1rem' }}>
                    No hay solicitudes en la categoría "{activeTab}".
                </p>
            )}

            {totalPages > 1 && (
                <Pagination
                    totalItems={filteredRequests.length}
                    itemsPerPage={itemsPerPage}
                    onItemsPerPageChange={setItemsPerPage}
                    currentPage={currentPage}
                    onNext={handleNextPage}
                    onPrevious={handlePreviousPage}
                    canNext={currentPage < totalPages}
                    canPrevious={currentPage > 1}
                />
            )}
        </div>
    );
};

export default PequenosDuenosAdmin;